export class MappingTipiEntitaFascicolo {
  public static FASCICOLO_ORDINARIO = '3426c0a8-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_CAUTELARE = '346d97a8-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_IMMOBILIARE = '34a51a4c-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_MOBILIARE = '34cd19f5-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_COTERZI = '34d1e966-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_INDAGINI_PRELIMINARI = '';
  public static FASCICOLO_MEDIAZIONE: number = 7;
  public static FASCICOLO_AZIONE_MONITORIA = '34e4ccf1-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_AZIONE_REVOCATORIA = '35aa05b7-e864-11ea-97d8-005056a8dd09';
  public static FASCICOLO_PRECETTO = '34ecdbf6-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_RECUPEROCREDITISTRAGIUDIZIALE: number = 10;
  public static FASCICOLO_PARERE = '3433695a-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_NEGOZIAZIONE_ASSISTITA: number = 12;
  public static FASCICOLO_TENTATIVO_OBBLIGATORIO_DI_CONCILIAZIONE: number = 13;
  public static FASCICOLO_ARBITRATO = '';
  public static FASCICOLO_OPPOSIZIONE = '8048c8a5-64ab-11eb-972a-005056a8dd09';
  public static FASCICOLO_OPPOSIZIONE_DECRETO_INGIUNTIVO = '';
  public static FASCICOLO_OPPOSIZIONE_ATTI_ESECUTIVI = '2c443926-905e-11ea-97d8-005056a8dd09';
  public static FASCICOLO_OPPOSIZIONE_PRECETTO = '34ecdbf6-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_OPPOSIZIONE_ESECUZIONE = 'a176da7d-e915-11ea-97d8-005056a8dd09';
  public static FASCICOLO_SPECIALE = '3475c49e-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_RICORSO = '34affbac-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_SOMMARIOURGENZA = '';
  public static FASCICOLO_RICORSOSTRAORDINARIO_PRESIDENTEREP: number = 24;
  public static FASCICOLO_RICORSOGERARCHICO: number = 25;
  public static FASCICOLO_RICORSO_OPPOSIZIONE = '';
  public static FASCICOLO_APPELLO = '3494c3c3-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_REVOCAZIONE = '349b296f-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_OPPOSIZIONE_DI_TERZO: number = 29;
  public static FASCICOLO_RICORSO_AL_TAR = '';
  public static FASCICOLO_RICORSO_LAVORO = '34affbac-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_RITO_FORNERO = '34b48613-53e9-11ea-a08d-005056a8dd09';
  public static FASCICOLO_RICORSO_CASSAZIONE = '';
  public static FASCICOLO_DIBATTIMENTO_PENALE = '';
  public static FASCICOLO_RITI_ALTERNATIVI: number = 37;
  public static FASCICOLO_AUTORITA_INDIPENDENTI_REGOLATORIE: number = 39;
  public static FASCICOLO_AMIANTO_STRAGIUDIZIALE = '2c444211-905e-11ea-97d8-005056a8dd09';
  public static FASCICOLO_AMIANTO_GIUDIZIALE = '2c4448bc-905e-11ea-97d8-005056a8dd09';
  public static FASCICOLO_SINISTRO_SANITARIO = '11ebe47d-70f0-264c-baa3-005056a8dd09';
  //Disabilitato temporaneamente
  public static FASCICOLO_RICORSO_AMMINISTRATIVO = '';
}
